import { AwsRum, AwsRumConfig } from 'aws-rum-web';

export type RumClientConfig = {
  appMonitorId: string;
  identityPoolId: string;
  guestRoleArn: string;
  sessionSampleRate: number;
  region: string;
  urlsToTrace: RegExp[];
};

let awsRum: AwsRum | null = null;

export const RumClient = {
  initialise: ({
    appMonitorId,
    identityPoolId,
    guestRoleArn,
    sessionSampleRate = 1,
    region = 'ap-southeast-2',
    urlsToTrace = [],
  }: RumClientConfig) => {
    const rumConfig: AwsRumConfig = {
      allowCookies: true,
      endpoint: 'https://dataplane.rum.ap-southeast-2.amazonaws.com',
      guestRoleArn: guestRoleArn,
      identityPoolId: identityPoolId,
      sessionSampleRate,
      telemetries: [
        'performance',
        'errors',
        ['http', { addXRayTraceIdHeader: urlsToTrace }],
      ],
      enableXRay: true,
    };

    awsRum = new AwsRum(appMonitorId, '1.0.0', region, rumConfig);
  },
  recordError(error: any) {
    if (awsRum) {
      awsRum.recordError(error);
    } else {
      console.warn('RUM client not initialized');
    }
  },
};
